var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX5Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20.58,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.2903C21.5 15.6665 16.8309 20.0806 11 20.0806C5.16908 20.0806 0.5 15.6665 0.5 10.2903C0.5 4.91416 5.16908 0.5 11 0.5C16.8309 0.5 21.5 4.91416 21.5 10.2903Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.588 14L7.24 10.256L4.564 6.464H5.692L7.864 9.536L9.856 6.464H10.996L8.38 10.244L11.092 14H9.94L7.756 10.988L5.716 14H4.588ZM14.6752 14.144C14.1992 14.144 13.7652 14.058 13.3732 13.886C12.9812 13.714 12.6672 13.462 12.4312 13.13C12.1952 12.794 12.0752 12.384 12.0712 11.9H13.0072C13.0072 12.356 13.1672 12.7 13.4872 12.932C13.8112 13.164 14.2072 13.28 14.6752 13.28C15.2152 13.28 15.6392 13.116 15.9472 12.788C16.2592 12.456 16.4152 12.048 16.4152 11.564C16.4152 10.596 15.7912 10.112 14.5432 10.112H12.5272L12.8512 6.464H17.0272V7.316H13.6072L13.7992 6.992L13.5472 9.62L13.4272 9.512C13.6192 9.468 13.8372 9.438 14.0812 9.422C14.3252 9.402 14.5432 9.392 14.7352 9.392C15.5512 9.392 16.1972 9.574 16.6732 9.938C17.1492 10.302 17.3872 10.844 17.3872 11.564C17.3872 12.052 17.2772 12.492 17.0572 12.884C16.8372 13.272 16.5232 13.58 16.1152 13.808C15.7112 14.032 15.2312 14.144 14.6752 14.144Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX5Black);
export default __webpack_public_path__ + "static/media/X5_Black.f6d775362c4fa1395aefb46e4f9fd74c.svg";
export { ForwardRef as ReactComponent };